.fi{border:1px solid #ddd;}